// extracted by mini-css-extract-plugin
export default {"App":"App_App__7BBxi","ShiftToRight":"App_ShiftToRight__1Glo7","Light":"App_Light__hsFWP","Dark":"App_Dark__OmuqX"};